import React from 'react';

import CuotaVendedor from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Unilever/CuotaVendedor/List.js';

export default function () {
  return <CuotaVendedor />;
}
